import { v4 as uuid } from 'uuid';
import { Timestamp } from '../../../../interfaces/index.types';
import { IFoodDetails } from '../../menu.types';

export const createDefaultValues = (): IFoodDetails => ({
  id: generateShortUuid(),
  name: '',
  sku: '',
  tax_rate: '',
  max_quantity_per_order: 0,
  tags_raw: '',
  food_show_status: 0,
  isEnableStockCount: false,
  enabled: true,
  unit_price: 0,
  price: 0,
  food_id: '',
  customize_group_settings: [],
  tags: [],
  min_quantity_per_order: 1,
  foodStockCount: '',
  long_name: '',
  image_url: '',
  categories: [],
  enabled_note: false,
  is_alcoholic: false,
  sold_out: '',
  description: '',
  restaurantId: '',
  create_time: { seconds: Math.floor(Date.now() / 1000), nanoseconds: 0 } as Timestamp,
  food_type: '',
  pre_order_quantity: 0,
});

function generateShortUuid(): string {
  const fullUuid = uuid().replace(/-/g, '');
  return fullUuid.slice(0, 10);
}
